export default () => ({
  users: [],
  currentUser: {},
})
